import { render, staticRenderFns } from "./ClassManageCourse.vue?vue&type=template&id=605b77c6&scoped=true&"
import script from "./ClassManageCourse.vue?vue&type=script&lang=js&"
export * from "./ClassManageCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605b77c6",
  null
  
)

export default component.exports